//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
let d=[[[0,"AssignTangencySide",1,0],[0,"SelectedTangencyGroup",1,"Routing.TangencyGroupBuilder",0]],[[["segments","tangencySide"],"AssignTangency",{},2,0],[["tangencySide"],"AssignTangencyAtPort",{},1,0],[["tangencySide"],"RemoveTangency",{},1,0],[[],"CreateTangencyGroupBuilder",{R_:{tangencyGroupBuilder:"Routing.TangencyGroupBuilder"}},0,0]],[]];
SPLM.Routing.AssignTangencyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.AssignTangencyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.AssignTangencyBuilder.TangencySide = Object.freeze({
    "Undefined" : "Undefined", "Source" : "Source", "Target" : "Target"});

export default SPLM;